import axios from 'axios';
import handleApiResponse from './utils';

const getOrganization = async ({ __config, internalManagingOrganizationID }) => {
	let response = await axios.get(
		`${__config.data_sources.fhir}/Organization/${internalManagingOrganizationID}?_dc=${new Date().getTime()}`
	);

	response = handleApiResponse(response);
	return response?.data;
};

export default getOrganization;
